import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesIncompleteChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.numIncompleteDeliveryNotes",
		title: "Incomplete Delivery Notes",
		yAxisLabel: "Incomplete (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.numIncompleteDeliveryNotes,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.numIncompleteDeliveryNotes );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
